import styled from "@emotion/styled";
import isStyledPropsValid from "utils/isStyledPropsValid";
import { Button, IconButton } from "@metacrm/metacrm-material-ui/dist/Button";
import { Box } from "@mui/material";

export const StyledUserInfoContainer = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme }) => {
  return {
    background: "#FFFFFF",
    borderBottom: "1px solid #D6D6D6",
    padding: "8px 12px",
  };
});

export const StyledUserInfoTitleContainer = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme }) => {
  return {
    background: "#FFFFFF",
    padding: "28px 16px",
  };
});
export const StyledUserBasicInfoContainer = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme, isTicketUserInfo }) => {
  return {
    background: theme.customColors.white,
    borderRadius: isTicketUserInfo ? "8px" : 0,
    width: "100%",
  };
});

export const StyledTitle = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme, sx }) => {
  return {
    fontSize: "16px",
    fontWeight: 500,
    marginBottom: "8px",
    ...sx,
  };
});
export const WalletCardContainer = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme, isSelected, sx }) => {
  return {
    position: "relative",
    border: isSelected ? `1px solid ${theme.customColors.purple[500]}` : "none",
    borderRadius: "8px",
    padding: "20px 24px",
    width: "100%",
    cursor: "pointer",
    backgroundColor: "#fff",
    "&:hover": {
      boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    },
    ...sx,
  };
});

export const StyledCurrentTicketLabel = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme }) => {
  return {
    position: "absolute",
    top: "20px",
    right: "16px",
    backgroundColor: theme.customColors.purple[500],
    color: "white",
    fontSize: 10,
    padding: "6px 10px",
    borderRadius: "99px",
  };
});

export const StyledRefreshButton = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme }) => {
  return {
    position: "absolute",
    top: "20px",
    right: "16px",
  };
});

export const StyledDivider = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ sx, noBorder, addPadding }) => ({
  borderBottom: noBorder ? "none" : "1px solid #E6E6E6",
  width: addPadding ? "calc(100% - 32px)" : "100%",
  margin: addPadding ? "0 16px" : 0,
  ...sx,
}));

export const AvatarRow = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme, sx }) => {
  return {
    display: "flex",
    alignItems: "center",
    fontSize: 14,
    color: "#777",
    ...sx,
  };
});

export const StyledFieldContainer = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme, sx }) => {
  return {
    padding: "24px 16px",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    ...sx,
  };
});
export const StyledIconField = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme, sx }) => {
  return {
    display: "flex",
    alignContent: "center",
    alignItems: "center",
    gap: "8px",
    marginBottom: "8px",
    "&:last-child": {
      marginBottom: 0,
    },
    ...sx,
  };
});
export const StyledFieldLabel = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme, sx }) => {
  return {
    fontSize: 12,
    fontWeight: 600,
    color: theme.customColors.grey[500],
    ...sx,
  };
});
export const StyledFieldValue = styled(Box, {
  shouldForwardProp: isStyledPropsValid,
})(({ theme, sx }) => {
  return {
    fontSize: 14,
    fontWeight: 400,
    color: theme.customColors.grey[700],
    ...sx,
  };
});

export const CopyIconButton = styled("div")({
  display: "inline-flex",
  marginLeft: 0,
  cursor: "pointer",
});

export const StyledSliderButton = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== "side",
})(({ side, show, theme }) => ({
  position: "absolute",
  top: "105px",
  [side]: "-16px",
  transform: "translateY(-50%)",
  zIndex: 10,
  backgroundColor: theme.palette.common.white,
  boxShadow: theme.shadows[1],
  display: show ? "block" : "none",
  width: "25px",
  height: "25px",

  "&:hover": {
    backgroundColor: "#fff",
  },
}));
